let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("zXFQE")).then(() => parcelRequire('7sEYG'));